import { createAction, props } from '@ngrx/store';

import {
    ICodeVerifySuccess,
    ICountersSaveSuccess,
    ICountersSuccess,
    ICreateCodeSuccess,
    IParamsCreateCode,
    IPreRegister,
    ISuccesfull,
    Users,
} from '../../shared/models/ApplicationUser';
import {
    ILoginTelPass,
    IPreRegisterUser,
    IRefreshAuthTokenRequest,
    IRefreshAuthTokenResponse,
    IRegisterUser,
    TenderoLogin,
    TenderoUpdated,
} from '../../shared/models/TenderoLogin.interface';

/**
 * * Baja los datos actualizados del usuario
 */
export const updatedUserData = createAction(
    '[UpdatedUserData] Updated User Data',
    props<TenderoUpdated>()
);

export const successUpdatedUserData = createAction(
    '[UpdatedUserData] Updated User Data Success',
    props<Users>()
);

export const errorUpdatedUserData = createAction(
    '[UpdatedUserData] Updated User Data Error',
    props<{ payload: Error }>()
);

export const clearUpdatedUserData = createAction(
    '[UpdatedUserData] Updated User Data Ckear'
);

/**
 * * Realiza el login del usuario
 */
export const loginTelPass = createAction(
    '[LoginTelPass] Login Tel-Pass Data',
    props<ILoginTelPass>()
);

export const successLoginTelPass = createAction(
    '[LoginTelPass] Login Tel-Pass Data Success',
    props<TenderoLogin>()
);

export const errorLoginTelPass = createAction(
    '[LoginTelPass] Login Tel-Pass Data Error',
    props<{ payload: any }>()
);

export const clearLoginTelPass = createAction(
    '[LoginTelPass] Clear Login Tel-Pass Data'
);

/**
 * * Realiza el registro del usuario
 */
export const registerUser = createAction(
    '[RegisterUser] Register User Data',
    props<IRegisterUser>()
);

export const successRegisterUser = createAction(
    '[RegisterUser] Register User Data Success',
    props<ISuccesfull>()
);

export const errorRegisterUser = createAction(
    '[RegisterUser] Register User Data Error',
    props<{ payload: Error }>()
);

export const clearRegisterUser = createAction(
    '[RegisterUser] Clear Register User Data'
);

/**
 * * Realiza validacion inicial del usuario
 */
export const preRegisterUser = createAction(
    '[PreRegisterUser] Register User Data',
    props<IPreRegisterUser>()
);

export const successPreRegisterUser = createAction(
    '[PreRegisterUser] Register User Data Success',
    props<IPreRegister>()
);

export const errorPreRegisterUser = createAction(
    '[PreRegisterUser] Register User Data Error',
    props<{ payload: Error }>()
);

export const clearPreRegisterUser = createAction(
    '[PreRegisterUser] Clear Register User Data'
);

/**
 * * Realiza validacion telfono cambio contraseña
 */
export const phoneVaidationPass = createAction(
    '[PhoneVaidationPass] Validate exist phone',
    props<{ Telefono: number; }>()
);

export const successPhoneVaidationPass = createAction(
    '[PhoneVaidationPass] Validate exist phone Success',
    props<ISuccesfull>()
);

export const errorPhoneVaidationPass = createAction(
    '[PhoneVaidationPass] Validate exist phone Error',
    props<{ payload: Error }>()
);

export const clearPhoneVaidationPass = createAction(
    '[PhoneVaidationPass] Clear Validate exist phone'
);

/**
 * * Realiza cambio contraseña
 */
export const ChangePass = createAction(
    '[ChangePass] Change Pass from login',
    props<{ Telefono: string; Contrasena: string; }>()
);

export const successChangePass = createAction(
    '[ChangePass] Change Pass from login Success',
    props<ISuccesfull>()
);

export const errorChangePass = createAction(
    '[ChangePass] Change Pass from login Error',
    props<{ payload: Error }>()
);

export const clearChangePass = createAction(
    '[ChangePass] Clear Change Pass from login'
);

/**
 * * Obtiene los contadores por dispositivo
 */
export const Counters = createAction(
    '[Counters] Counters for devices',
);

export const successCounters = createAction(
    '[Counters] Counters for devices Success',
    props<ICountersSuccess>()
);

export const errorCounters = createAction(
    '[Counters] Counters for devices Error',
    props<{ payload: Error }>()
);

export const setCounter = createAction(
    '[Counters] Set Counters to redux',
    props<{ ID_Flujo: number; ExcedeLimite: boolean; UltimoRegistro: string; }>()
);

export const clearCounters = createAction(
    '[ChangePass] Clear Counters for devices'
);

/**
 * * Guarda contador por dispositivo
 */
export const CountersSave = createAction(
    '[CountersSave] Counters Save for devices',
    props<{ flowId: number; metadata: string; }>()
);

export const successCountersSave = createAction(
    '[CountersSave] Counters Save for devices Success',
    props<ICountersSaveSuccess>()
);

export const errorCountersSave = createAction(
    '[CountersSave] Counters Save for devices Error',
    props<{ payload: Error }>()
);

export const clearCountersSave = createAction(
    '[ChangePass] Clear Counters Save for devices'
);

/**
 * * Envio de verficacion de sms
 */
export const SendSmsPhone = createAction(
    '[SendSmsPhone] Send Sms Phone',
    props<IParamsCreateCode>()
);

export const successSendSmsPhone = createAction(
    '[SendSmsPhone] Send Sms Phone Success',
    props<ICreateCodeSuccess>()
);

export const errorSendSmsPhone = createAction(
    '[SendSmsPhone] Send Sms Phone Error',
    props<{ payload: Error }>()
);

export const clearSendSmsPhone = createAction(
    '[SendSmsPhone] Clear Send Sms Phone'
);

/**
 * * Envio de verficacion de codigo de verificacion
 */
export const SendCodeVerify = createAction(
    '[SendCodeVerify] Send Code Verify',
    props<{ Telefono: string; Codigo: string; }>()
);

export const successSendCodeVerify = createAction(
    '[SendCodeVerify] Send Code Verify Success',
    props<ICodeVerifySuccess>()
);

export const errorSendCodeVerify = createAction(
    '[SendCodeVerify] Send Code Verify Error',
    props<{ payload: Error }>()
);

export const clearSendCodeVerify = createAction(
    '[SendCodeVerify] Clear Send Code Verify'
);

/**
 * Refresh token de autenticación
 */
export const RefreshAuthToken = createAction(
    '[RefreshAuthToken] Refresh Token',
    props<IRefreshAuthTokenRequest>()
)

export const successRefreshAuthToken = createAction(
    '[RefreshAuthToken] Refresh Token Success',
    props<IRefreshAuthTokenResponse>()
);

export const errorRefreshAuthToken = createAction(
    '[RefreshAuthToken] Refresh Token Error',
    props<{ payload: Error }>()
);

export const clearRefreshAuthToken = createAction(
    '[RefreshAuthToken] Clear Refresh Token'
);